import { decode } from 'base64-arraybuffer';
import { escapeRegExp } from 'lodash';

/**
 * @param {String} b64Data - file content in base64
 * @param {String} contentType - {String}
 * @returns {Blob} - required for createUrlObject so we can store URL instead of base64 in redux state
 *
 * More Info on Blobs: https://developer.mozilla.org/en-US/docs/Web/API/Blob
 */
export const b64toBlob = (b64Data, contentType='') => {
  const res = decode(b64Data);
  return new Blob([res], {type: contentType});
};

/**
 * Returns a new string with the white space of the text replaced with a white space regex match.
 * examples: "The quick brown fox jumps over the lazy dog" -> "The\s+quick\s+brown\s+fox\s+jumps\s+over\s+the\s+lazy\s+dog"
 *           "many       spaces" -> "many\s+spaces"
 */
export const replaceWhiteSpaceWithRegexMatch = text => {
  const words = text.match(/\S+/g);
  return words ? words.join('\\s+') : text;
};

/**
 * Builds a regular expression from the provided text by escaping the text and replacing multiple spaces with white space matches.
 * @param text The text to convert to a regular expression.
 * @param flags Options regex flags. Defaults to 'ig' which ignores case and searches globally.
 */
export const buildRegex = (text, flags) => {
  return flags ? new RegExp(replaceWhiteSpaceWithRegexMatch(escapeRegExp(text)), flags) : new RegExp(replaceWhiteSpaceWithRegexMatch(escapeRegExp(text)), 'ig');
};
